import { amplitudeLib } from 'freedom-shared';

import type { MainPageVariant } from './main-page';

export const lastSearchesShow = (variant?: MainPageVariant) => {
  amplitudeLib.logEvent('last_searches_show', {
    main_page_variant: variant,
  });
};

export const lastSearchesClick = (
  number: number,
  variant?: MainPageVariant,
) => {
  amplitudeLib.logEvent('last_searches_click', {
    number,
    main_page_variant: variant,
  });
};

export const lastSearchesRemove = (
  number: number,
  variant?: MainPageVariant,
) => {
  amplitudeLib.logEvent('last_searches_remove', {
    number,
    main_page_variant: variant,
  });
};
